import * as types from './actionTypes';

// ─────────────────────────────
// FETCH CHAPTERS
// ─────────────────────────────
export const fetchChaptersRequest = (params = {}) => ({
  type: types.FETCH_CHAPTERS_REQUEST,
  payload: params,
});

export const fetchChaptersSuccess = (data) => ({
  type: types.FETCH_CHAPTERS_SUCCESS,
  payload: data,
});

export const fetchChaptersFailure = (error) => ({
  type: types.FETCH_CHAPTERS_FAILURE,
  payload: error,
});

// ─────────────────────────────
// ADD CHAPTER
// ─────────────────────────────
export const addChapterRequest = (data, callback) => ({
  type: types.ADD_CHAPTER_REQUEST,
  payload: { data, callback },
});

export const addChapterSuccess = (data) => ({
  type: types.ADD_CHAPTER_SUCCESS,
  payload: data,
});

export const addChapterFailure = (error) => ({
  type: types.ADD_CHAPTER_FAILURE,
  payload: error,
});

// ─────────────────────────────
// UPDATE CHAPTER
// ─────────────────────────────
export const updateChapterRequest = (id, data, callback) => ({
  type: types.UPDATE_CHAPTER_REQUEST,
  payload: { id, data, callback },
});

export const updateChapterSuccess = (data) => ({
  type: types.UPDATE_CHAPTER_SUCCESS,
  payload: data,
});

export const updateChapterFailure = (error) => ({
  type: types.UPDATE_CHAPTER_FAILURE,
  payload: error,
});

// ─────────────────────────────
// DELETE CHAPTER
// ─────────────────────────────
export const deleteChapterRequest = (id) => ({
  type: types.DELETE_CHAPTER_REQUEST,
  payload: id,
});

export const deleteChapterSuccess = (data) => ({
  type: types.DELETE_CHAPTER_SUCCESS,
  payload: data,
});

export const deleteChapterFailure = (error) => ({
  type: types.DELETE_CHAPTER_FAILURE,
  payload: error,
});
